<div class="modal-header align-items-center">
  <h4 class="modal-title synchpc-primary mb-0" id="modal-title">Download Job info</h4>
  <i style="z-index: 1; cursor: pointer;" class="bi bi-x-lg text-danger" color="warn" (click)="onCancel()" title="Close"></i>
</div>

<div class="modal-body p-3 text-grey">
  <div class="border rounded p-3 mb-3">
    <div class="d-flex justify-content-between align-items-center mb-2">
      <h3 class="mb-0">Job Info Templates</h3>
      <button class="btn btn-sm btn-outline-secondary py-1" (click)="showSaveTemplate()">
        <i class="bi bi-plus-lg me-1"></i>New
      </button>
    </div>
    
    <div class="saved-templates" style="max-height: 100px; overflow-y: auto;">
      <div *ngFor="let template of templates" 
            class="template-item d-flex justify-content-between align-items-center py-2 px-1 border-bottom">
        <span class="text-truncate pe-2" style="max-width: 150px;" [title]="template.name">
          {{ template.name }}
        </span>
        <div class="btn-group btn-group-sm">
          <button class="btn btn-outline-primary py-1 px-2" 
          title="Use this template"
          (click)="loadTemplate(template)">
            <i class="bi bi-check-lg"></i>
          </button>
          <button class="btn btn-outline-danger py-1 px-2" (click)="deleteTemplate(template)">
            <i class="bi bi-trash"></i>
          </button>
        </div>
      </div>
    </div>

    <div *ngIf="isShowingSaveTemplate" class="mt-3">
      <div class="input-group input-group-sm">
        <input type="text" 
              class="form-control form-control-sm" 
              [(ngModel)]="newTemplateName" 
              placeholder="Template name">
        <button class="btn btn-outline-primary" (click)="saveTemplate()">
          <i class="bi bi-save me-1"></i>Save
        </button>
      </div>
    </div>
  </div>

  <div class="fields-section">
    <p class="mb-2 text-secondary small fw-bold">Select the fields to be shown in downloaded file.</p>    
    <div class="select-all mb-2">
      <div class="form-check">
        <input type="checkbox" 
              class="form-check-input" 
              id="selectAll" 
              [checked]="isAllSelectedCheck()" 
              (click)="selectAll()">
        <label class="form-check-label" for="selectAll">Select All</label>
      </div>
    </div>

    <div class="fields-container">
      <div class="row g-0">
        <div class="col-6">
          <div *ngFor="let field of fieldsObj; let i = index">
            <div *ngIf="!field.isMandatory && i % 2 === 0" class="form-check mb-1 pe-2">
              <input type="checkbox" 
                    class="form-check-input"
                    [name]="field.name" 
                    [id]="field.name" 
                    [checked]="field.isChecked" 
                    [(ngModel)]="field.isChecked">
              <label class="form-check-label text-nowrap" [for]="field.name">
                {{ field.name | makeUpper }}
              </label>
            </div>
          </div>
        </div>
        <div class="col-6">
          <div *ngFor="let field of fieldsObj; let i = index">
            <div *ngIf="!field.isMandatory && i % 2 === 1" class="form-check mb-1 pe-2">
              <input type="checkbox" 
                    class="form-check-input"
                    [name]="field.name" 
                    [id]="field.name" 
                    [checked]="field.isChecked" 
                    [(ngModel)]="field.isChecked">
              <label class="form-check-label text-nowrap" [for]="field.name">
                {{ field.name | makeUpper }}
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <ngx-spinner bdColor="rgba(0,0,0,0)"
              size="default" zIndex="1"
              color="var(--s-primary-color)"
              type="ball-spin"
              [fullScreen]="false"><p>Please wait ...</p></ngx-spinner>

</div>

<div class="modal-footer pt-2">
  <button type="button" class="btn btn-sm btn-outline-secondary" (click)="onCancel()">Cancel</button>
  <button type="button" class="btn btn-sm btn-primary" (click)="onSubmit()">Download</button>
</div>
